module.exports = __webpack_public_path__ + "static/logoIFSblackV2.e139d232.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/logoIFSblackV2.png
// module id = 541
// module chunks = 114276838955818